import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ActivityACHPage from "components/pages/ActivityACHPage";
import { getDefaultData } from "components/pages/OneTimeACHPaymentPage";
import Classes, { ACHBatch } from "model";

export default function CaptureBatchInitiated(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const effectiveDate = BCMSDate.init().nextBusinessDay().nextBusinessDay();
    const secCode = ACHBatch.getSelectedSecCodeByBranding();

    const achBatchesSorted = ACHBatch.initAll()
    .filter(item => item.id !== undefined)
    .sort((a, b) => parseFloat(b.referenceNumber) - parseFloat(a.referenceNumber))

    const achBatch = ACHBatch.init({
        id: ACHBatch.nextID(),
        name: "One-Time",
        transactionType: "payment",
        secCode: secCode,
        scheduleType: "future dated",
        effectiveDate: effectiveDate,
        creditAmount: "5000.00",
        debitAmount: "5000.00",
        companyEntryDescription: "ACH PMT",
        company: "0",
        referenceNumber: parseFloat(achBatchesSorted[0].referenceNumber) + 1
    });

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "submittedOneTimeACHPayment" ], achBatch)
    .submit();

    return <ActivityACHPage data={ data } />;
}